import React, { useEffect, useRef } from 'react';
import '../styles/global_styles.css';
import Header  from '../components/Header';
import Hero from '../components/Hero';
import Asociate from '../components/Asociate';
import Servicios from '../components/Servicios';
import Planes from '../components/Planes';
import Contacto from '../components/Contacto';
import globalStore from '../store/global';
import { navigate } from "wouter/use-browser-location";
import { useLocation } from 'wouter';
import { CheckCircleOutline } from '@mui/icons-material';
import logotexto from './../assets/images/logotipo.jpg'
import CotizadorStore from "../store/cotizador";

type SeccionsRefs = {
  [key: string]: HTMLElement | null;
};

const SuscripcionExitosa = () => {
  
  const {reiniciarCotizador} = CotizadorStore();
  const [, setLocation] = useLocation();
  
  const replaceUrl = (newUrl: string) => {
    setLocation(newUrl, { replace: true });
  };

  const reiniciarCotizadorLocal = () => {
    reiniciarCotizador();
    replaceUrl('/');
  };

  return (
    <div className="flex flex-col justify-center items-center flex-grow w-full h-dvh bg-white">
        <img src={logotexto} className="mb-4 h-[100px] " alt="VidaPlus Logo" />
        <CheckCircleOutline fontSize="large" className="text-vp-verde" />
        <h3 className="text-2xl font-bold mt-4">¡Suscripción exitosa!</h3>
        <p className="text-center mt-4">¡Gracias por confiar en nosotros!</p>
        <p className="text-center mt-4">En breve recibirás un correo con los detalles de tu suscripción.</p>
        <button className="vp-btn-azul mt-4" onClick={() => reiniciarCotizadorLocal()}>Volver al inicio</button>
    </div>
  );
};

export default SuscripcionExitosa;